/**
 * useOnboarding Hook
 *
 * Provides easy access to onboarding functionality.
 * Use this hook in components that need to interact with the tooltip system.
 */

import { useOnboardingContext } from '../contexts/OnboardingContext';

export const useOnboarding = () => {
  const context = useOnboardingContext();

  return {
    // State
    enabled: context.enabled,
    dismissedTips: context.dismissedTips,

    // Actions
    dismissTip: context.dismissTip,
    skipAll: context.skipAll,
    reset: context.reset,

    // Queries
    isTipDismissed: context.isTipDismissed,
  };
};
